import { SchoolModel } from '@modules/school/school-model';

const { fields } = SchoolModel;

export default [
        fields.id,

        fields.createdAt
];